<template>
    <div class="TQ_center ">
        <tq-loader-container :p_show-loader_b="server_currentUserData_c === undefined" >
            <div v-if="server_currentUserData_c !== undefined" >

                <!-- 1) enter ticket short key -->
                <div class="TQ_width_100p" :class="orderedTicketsIds_as.length === 0 && 'TQ_centerAbsolute'">
                    <div class="TQ_margin_16px TQ_inline TQ_maxWidth_300px TQ_width_100p TQ_borderRadius TQ_box_shadow">

                        <!-- title -->
                        <div class="TQ_borderRadius_top TQ_borderBox TQ_bg_purple TQ_padding_8px" >
                            <div class="TQ_padding_2px"></div>
                            <si_full-logo class="TQ_width_52px TQ_borderRadius TQ_margin_bottom_-4px"/>
                            <h1 class="TQ_text_20px TQ_font_SecularOne">
                                {{ ass_strings.twoWords_travelQuest[store_system_langCode_ve.val] }}
                            </h1>
                        </div>

                        <!-- enter quest code-->
                        <div class="TQ_bg_white TQ_padding_16px TQ_width_100p TQ_borderBox TQ_borderRadius_bottom " >

                            <input class="TQ_padding_8px TQ_width_100p TQ_borderBox TQ_text_20px TQ_center TQ_border_gray TQ_borderRadius  "
                                   @input="m_inputShortTicketCode_f"
                                   :placeholder="ass_strings.twoWords_entryCode[store_system_langCode_ve.val]"
                                   v-model="formattedShortTicketKey"/>

                            <div class="TQ_clickable TQ_box_shadow TQ_padding_8px TQ_text_20px TQ_bg_purple_lite TQ_borderRadius TQ_borderBox TQ_margin_top_16px TQ_grid_col_Auto1frAuto"
                                 @click="m_enterTicketShortKey_f">
                                <div class="TQ_square_8px TQ_grid_center TQ_padding_4px"></div>

                                <div class="TQ_grid_center">
                                    {{ass_strings.oneWord_Continue[store_system_langCode_ve.val]}}
                                </div>
                                <div class="TQ_square_8px TQ_bg_circle TQ_grid_center TQ_padding_4px" :class="formattedShortTicketKey.length===12 && 'TQ_animation_beacon'"></div>
                            </div>


                        </div>

                        <!-- bottom go to store-->
                        <div class="TQ_bg_purple TQ_borderRadius_bottom TQ_padding_8px TQ_font_SecularOne TQ_text_capitalize_first_letter" v-if="orderedTicketsIds_as.length === 0">
                            {{ass_strings.fourWords_dontHaveEntryCode[store_system_langCode_ve.val]}}?
                            {{ass_strings.twoWords_moveTo[store_system_langCode_ve.val]}}
                            <tq-link :p_link_s="enum_moveToOptions.player_store" class="TQ_textColor_white TQ_text_capitalize">
                                {{ass_strings.oneWord_store[store_system_langCode_ve.val]}}
                            </tq-link>
                        </div>

                    </div>
                </div>

                <!-- 2) tickets -->
                <div v-if="orderedTicketsIds_as.length !== 0" >

                    <div class="TQ_bg_white TQ_center TQ_text_24px TQ_padding_16px TQ_text_capitalize">
                        {{ass_strings.threeWords_myEntryTickets[store_system_langCode_ve.val]}}
                    </div>

                    <div v-for="(ticketId,index) in orderedTicketsIds_as">
                        <c_-player_-tickets_-list_-ticket
                            :key="index"
                            :p_system-lang-code_e="store_system_langCode_ve.val"
                            :p_quest-event_c="questsEventsByTicketId[ticketId]"
                            :p_ticket-owner_b="m_dom_ticketOwner_fb(ticketId)"
                            :p_quest-event-ticket_c="tickets_byTicketId[ticketId]"
                            @click.native="m_userEvent_clickTicket(tickets_byTicketId[ticketId])"
                        />
                    </div>


                </div>

                <!-- 3) load more quest tickets btn -->
                <div>

                    <tq-loader-button  :show-loader="numOfWaitingToResponseCalls_n > 0"
                                       v-if="displayLoaderBtn_b || numOfWaitingToResponseCalls_n > 0 && orderedTicketsIds_as.length > 2"
                                       @clickBtn="m_userEvent_getNextThreeUserTickets_f"
                                       btn-class="TQ_padding_8px TQ_bg_purple TQ_inline TQ_margin_8px TQ_borderRadius"
                                       :text="ass_strings.threeWords_loadMoreTickets[store_system_langCode_ve.val]"/>
                </div>

                <!-- 4) popup ticket-->
                <tq-popup :show-close-btn="true"
                          :show="showPopup_ticketActions_vb"
                          v-if="selectedTicket"
                          max-width="230px"
                          padding="8px">

                    <div class="TQ_text_28px">
                        {{ass_strings.oneWord_actions[store_system_langCode_ve.val]}}
                    </div>

                    <hr>
                    <div class="TQ_margin_8px TQ_text_24px">

                        <!-- btn join quest-->
                        <div class="TQ_bg_green TQ_padding_12px TQ_borderRadius TQ_margin_bottom_8px TQ_box_shadow TQ_clickable TQ_grid_col_auto1fr"
                             @click="m_userEvent_clickJoinBtn(selectedTicket.qt_ticketId_uid, selectedTicket.qt_shortKeyId_s)" >
                            <img class="TQ_width_32px TQ_grid_verticalCenter TQ_margin_0_4px" :src="ass_img_power_w"/>
                            <div class="TQ_grid_verticalCenter"> {{ass_strings.twoWords_joinQuest[store_system_langCode_ve.val]}}</div>
                        </div>

                        <!-- btn copy link-->
                        <div class="TQ_bg_gold_w TQ_padding_12px TQ_borderRadius TQ_box_shadow TQ_clickable TQ_grid_col_auto1fr"
                             @click="m_userEvent_clickCopyLink()">
                            <img class="TQ_width_32px TQ_grid_verticalCenter TQ_margin_0_4px" :src="ass_img_link_w"/>
                            <div class="TQ_grid_verticalCenter"> {{ass_strings.twoWords_copyLink[store_system_langCode_ve.val]}} </div>
                        </div>

                    </div>

                </tq-popup>

            </div>
        </tq-loader-container>
    </div>
</template>

<script>

    import {
        serverPre_currentUserTickets_cl_set_f,
        serverPre_currentUserTickets_cl_remove_f,
        server_questEvent_once_f,
        server_questTicket_vl_set,
        server_questTicket_vl_remove,
        server_getTicketShortKey_f,
    } from "@/scripts/Server/S_ServerPre";
    import {
        enum_questTicketStatus, enum_screenSizesOptions_n,
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from '../../../components/basic/TqCard'
    import {route_addLangToPath_s, route_moveToRoute,} from "@/router";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "@/store";
    import {
        helper_copyStringToClipboard,
        helper_getDisplayLang_e,
        helper_getTicketUrl
    } from "@/scripts/S_Helper";
    import {notification_notify} from "@/scripts/S_Notification";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import c_Player_Tickets_Ticket from "./v_Player_Play_Item/c_Player_Play_Item_Ticket";
    import {
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_minutes,
        format_shortKey_fs
    } from "../../../../functions/src/shareCode/Share_S_Format";
    import TqPopup from "../../../components/basic/TqPopup";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {obj_forEach_f, obj_size_fn} from "../../../../functions/src/shareCode/Share_S_Obj";
    import {
        ass_img_clock,
        ass_img_download_b,
        ass_img_download_w,
        ass_img_garbage_w,
        ass_img_link_w,
        ass_img_playersGroup_b,
        ass_img_power_w,
        ass_img_profit_b,
        ass_img_reviews_w,
    } from "@/assets/scripts/Ass_Files";
    import TqOnTopContainer from "../../../components/basic/TqOnTopContainer";
    import TqLoaderButton from "../../../components/basic2/TqLoaderButton";
    import {
        enum_moveToOptions,
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "@/scripts/Server/S_ServerAuth";
    import Si_fullLogo from "../../../components/a_smartIcons/si_fullLogo";
    import C_Player_Tickets_List_Ticket from "./v_Player_Play_List/c_Player_Play_List_Ticket";
    import {date_pastXSecond_fb} from "@/scripts/S_Date";
    import Si_maze from "@/components/a_smartIcons/si_maze";
    import TqImage from "@/components/basic/TqImage";
    import TqLink from "@/components/basic/TqLink";

    export default {
        name: "v_player_tickets",
        components:{
            TqLink,
            TqImage,
            Si_maze,
            C_Player_Tickets_List_Ticket,
            Si_fullLogo,
            TqLoaderButton,
            TqOnTopContainer,
            TqPopup,
            TqLoaderContainer,
            TqCard,
            c_Player_Tickets_Ticket,
        },
        data(){
            return {

                // local data
                orderedTicketsIds_as                : [],
                currentUserTicketsIds_ByTicketIdB   : {},

                tickets_byTicketId                  : {},
                questsImgUrlByTicketId              : {},

                ticketId_byMonthLabel               : {},
                selectedTicket                      : null,

                showPopup_ticketActions_vb          : {val : false},
                approveCreatorRules_b               : false,
                showDownloadQuest_b                 : false,

                listenersTicketsIds_byTicketId_b    : {},

                listQueryTicketsPointers_as             : [],
                lastQueryTicketPointer_c            : null,
                numOfWaitingToResponseCalls_n       : 0,
                displayLoaderBtn_b                  : false,

                formattedShortTicketKey            : "",

                // store
                store_system_langCode_ve            : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve      : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // server
                server_currentUserData_c: undefined,
                server_questExplore_c   : undefined,
                questsEventsByTicketId  : {},

                // assents
                ass_strings     : ass_strings,

                ass_img_power_w : ass_img_power_w,
                ass_img_reviews_w : ass_img_reviews_w,
                ass_img_download_w : ass_img_download_w,
                ass_img_garbage_w : ass_img_garbage_w,
                ass_img_download_b : ass_img_download_b,
                ass_img_link_w : ass_img_link_w,
                ass_img_clock : ass_img_clock,
                ass_img_playersGroup : ass_img_playersGroup_b,
                ass_img_profit_b : ass_img_profit_b,

                enum_moveToOptions : enum_moveToOptions,
                enum_screenSizesOptions_n : enum_screenSizesOptions_n,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                format_duration_minutes : format_duration_minutes,
                obj_size_fn : obj_size_fn,
            }
        },
        computed:{
            co_qex_displayLangCode_e(){
                return helper_getDisplayLang_e(this.store_system_langCode_ve.val, this.server_questExplore_c.qex_langArr_ae, this.server_questExplore_c.qex_mainLang_e)
            },

        },
        methods: {

            // dom events
            m_dom_ticketOwner_fb(ticketId_uid){

                if(this.server_currentUserData_c == null){
                    return false
                }

                return this.server_currentUserData_c.ud_userId_uid === this.tickets_byTicketId[ticketId_uid].qt_playerId_uid
            },

            // User events
            m_userEvent_clickTicket(ticket_c){


                if(ticket_c.qt_status_e === enum_questTicketStatus.waitingToApprove){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_notApprovedByCreator)
                }
                else if(ticket_c.qt_status_e === enum_questTicketStatus.expired){
                    notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_TicketExpired)
                }
                else if(ticket_c.qt_status_e === enum_questTicketStatus.canceled){
                    notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_TicketCancel)
                }
                else{
                    this.showPopup_ticketActions_vb.val=true
                    this.selectedTicket = ticket_c
                }

            },
            m_userEvent_clickCopyLink(){
                this.showPopup_ticketActions_vb.val=false

                let ticketUrl = helper_getTicketUrl(this.selectedTicket.qt_ticketId_uid)

                helper_copyStringToClipboard(ticketUrl)
                notification_notify(ass_strings.twoWords_copiedLink)

            },
            m_userEvent_clickJoinBtn(ticketId_uid, shortKeyId_s) {
                store_setStateValue(store_var.ongoing_ticketShortKey_s, shortKeyId_s)
                route_moveToRoute(enum_moveToOptions.player_play_entry_ticket, {[enum_urlParams.ticketId] : ticketId_uid})
            },
            m_userEvent_getNextThreeUserTickets_f(){

                if(this.server_currentUserData_c == null){return}

                this.displayLoaderBtn_b = false

                this.listQueryTicketsPointers_as.push(this.lastQueryTicketPointer_c)

                serverPre_currentUserTickets_cl_set_f(this.$options.name, this.lastQueryTicketPointer_c, this.server_currentUserData_c.ud_userId_uid, ticketPointer_c =>{
                    if(this.lastQueryTicketPointer_c == null || this.lastQueryTicketPointer_c.qetp_orderBy_uid > ticketPointer_c.qetp_orderBy_uid){
                        this.lastQueryTicketPointer_c = ticketPointer_c
                        this.displayLoaderBtn_b = true
                    }

                    this.currentUserTicketsIds_ByTicketIdB[(ticketPointer_c.qetp_ticketId_uid)] = true

                    this.m_addQuestTicket_f(ticketPointer_c.qetp_ticketId_uid)
                })
            },

            m_inputShortTicketCode_f(){

                this.formattedShortTicketKey = format_shortKey_fs(this.formattedShortTicketKey)

                if(this.formattedShortTicketKey.length === 12){
                    // this.m_enterTicketShortKey_f()
                }


            },
            // enter ticket short key
            m_enterTicketShortKey_f(){

                if(this.formattedShortTicketKey.length < 12){
                    notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongCode)
                    return
                }


                let shortKeyId_s = "";
                [0,1,5,6,10,11].forEach((index) => {
                    shortKeyId_s += this.formattedShortTicketKey[index]
                })

                shortKeyId_s = shortKeyId_s.toLowerCase();



                server_getTicketShortKey_f({
                    ticketShortKeyId_s : shortKeyId_s,
                    cb_f : (ticketShortKey_c) => {

                        if(ticketShortKey_c == null){
                            notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongCode)
                        }else if(date_pastXSecond_fb(ticketShortKey_c.tsk_createDate_t, ticketShortKey_c.tsk_lifespanInDays_n * 24 * 60 * 60)){

                            notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_expired)

                        }else{

                            this.m_userEvent_clickJoinBtn(ticketShortKey_c.tsk_ticketId_uid, shortKeyId_s)
                        }
                    }
                });

            },

            // helpers
            m_addQuestTicket_f(ticketId){

                // check if already got ticket
                if(this.listenersTicketsIds_byTicketId_b[ticketId] || ticketId === '' || ticketId == null){return}
                this.listenersTicketsIds_byTicketId_b[ticketId] = true

                this.numOfWaitingToResponseCalls_n++


                server_questTicket_vl_set(this.$options.name, ticketId, true, newTicket_c => {


                    if(newTicket_c == null){
                        this.numOfWaitingToResponseCalls_n--
                        return
                    }

                    // 1) add ticket
                    this.$set(this.tickets_byTicketId, ticketId, newTicket_c)

                    // 2) add ticket quest event
                    if(!this.questsEventsByTicketId[ticketId]) {
                        this.questsEventsByTicketId[ticketId] = true;
                    
                        server_questEvent_once_f(newTicket_c.qt_questType_e, newTicket_c.qt_questId_uid, newTicket_c.qt_eventId_uid, true, questEvent_c => {

                            this.numOfWaitingToResponseCalls_n--

                            // TQ_HANDEL_NEW_CHANGES: removed quest event
                            if(questEvent_c == null){
                                return
                            }

                            this.$set(this.questsEventsByTicketId, ticketId, questEvent_c)
                            this.m_addQuestTicket_addTicketIdToOrderArr(ticketId)
                        })
                    }else{
                        this.numOfWaitingToResponseCalls_n--
                    }



                })

            },
            m_addQuestTicket_addTicketIdToOrderArr(ticketId){

                let added = false
                let questEvent1 = this.questsEventsByTicketId[ticketId]

                let index;
                for(index in this.orderedTicketsIds_as) {

                    let questEvent2 = this.questsEventsByTicketId[this.orderedTicketsIds_as[index]]

                    if(!questEvent1.qev_startingDate_t || questEvent1.qev_startingDate_t > questEvent2.qev_startingDate_t){

                        this.orderedTicketsIds_as.splice(index, 0, ticketId)
                        added = true;
                        break;
                    }
                }

                if(!added) {
                    this.orderedTicketsIds_as.splice(index+1, 0, ticketId)
                }

                if(this.orderedTicketsIds_as.length === 0){
                    this.orderedTicketsIds_as.push(ticketId)
                }

            },


        },
        activated(){

            // get current user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {

                // first login
                if(this.server_currentUserData_c == null && currentUserData_c != null){
                    this.server_currentUserData_c = currentUserData_c
                    this.m_userEvent_getNextThreeUserTickets_f()
                }else{
                    this.server_currentUserData_c = currentUserData_c
                }

            })

        },
        deactivated(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },
        destroyed(){

            if(this.server_currentUserData_c != null){
                this.listQueryTicketsPointers_as.forEach(lastQuestTicketPointer_c => {
                    serverPre_currentUserTickets_cl_remove_f(this.$options.name, lastQuestTicketPointer_c, this.server_currentUserData_c.ud_userId_uid)
                })
            }


            obj_forEach_f(this.listenersTicketsIds_byTicketId_b, (value_b, ticketId_uid) => {

                server_questTicket_vl_remove(this.$options.name, ticketId_uid)
            })

        },
    }
</script>

<style scoped lang="scss">
 

</style>
